document.addEventListener('DOMContentLoaded', function(){
  console.log('<<<< InfiniteScroll by InnovateGroup >>>>')
  let IS_SCROLL = true;
  const pagination = document.querySelector('.template-collection .pagination');
  const heightPage = window.innerHeight;
  const URL = window.location.href;
  let realCounter = 1;
  let paginador = true;
  const chargingAlert = `<div id="ajaxCollectionCharging" class="ajaxCollectionChargingContainer">
                                <div class="loadingio-spinner-rolling-6ihd5j4345j">
                                    <div class="ldio-hlcdd83um6h"><div></div></div>
                                </div>
              </div>`
  if(pagination){    
    window.addEventListener('scroll', async function(e) {
      let enabler = 0;
      let currentScroll = window.scrollY;
      let posNavBarDefault = $('.pagination').offset()
      if(posNavBarDefault){
        let posNavBar = posNavBarDefault.top;
        if( (heightPage + currentScroll) >= posNavBar){
          enabler++
          paginador = false;
        }
        if(enabler != 0 && IS_SCROLL){
          IS_SCROLL = false;
          realCounter++
          if ( !document.getElementById('ajaxCollectionCharging') ) pagination.insertAdjacentHTML('beforebegin', chargingAlert);
          const lastItemPagination = [...pagination.querySelectorAll('.page')].at(-1);
          if(realCounter <= (Number(lastItemPagination.textContent))){
            const request = await fetch(`${URL}?page=${realCounter}`)
            const response = await request.text();
            let elements = $(response).find('.grid--collection');
            [...elements].forEach( cell => {
              $(cell).find('.grid-product__image').addClass(`infinite_slick-${realCounter}`)
              cell.classList.add('aos-init', 'aos-animate')
              $('.grid--collection').append( cell )

              setTimeout(() => {
                  createSlick(`.infinite_slick-${realCounter}`)
              }, 400);
            })
            IS_SCROLL = true
          }

          if ( document.getElementById('ajaxCollectionCharging') ) document.getElementById('ajaxCollectionCharging').parentNode.removeChild(document.getElementById('ajaxCollectionCharging'));
        }
        }
    })
  }

  document.addEventListener('filter:change', (evt) => {
    setTimeout(() => {
      createSlick('.grid-product__image')
      updateSizes('.grid-product')
      window.scroll({top: 0, behavior: "smooth"})
    }, 400);
  })
})